/**
 * Calendar colours (DESIGN.md "Calendar colours"). Full class names, so Tailwind finds them:
 * `stripe` is the 3px left edge, `tint` the 10% background, `swatch` the solid sample.
 * `own` is the style of the user's own events (the accent).
 */
export const calendarColors = {
  "cal-1": {
    name: "Teal",
    stripe: "border-l-cal-1",
    tint: "bg-cal-1/10",
    swatch: "bg-cal-1",
  },
  "cal-2": {
    name: "Sage",
    stripe: "border-l-cal-2",
    tint: "bg-cal-2/10",
    swatch: "bg-cal-2",
  },
  "cal-3": {
    name: "Sand",
    stripe: "border-l-cal-3",
    tint: "bg-cal-3/10",
    swatch: "bg-cal-3",
  },
  "cal-4": {
    name: "Rose",
    stripe: "border-l-cal-4",
    tint: "bg-cal-4/10",
    swatch: "bg-cal-4",
  },
  "cal-5": {
    name: "Violet",
    stripe: "border-l-cal-5",
    tint: "bg-cal-5/10",
    swatch: "bg-cal-5",
  },
  "cal-6": {
    name: "Slate",
    stripe: "border-l-cal-6",
    tint: "bg-cal-6/10",
    swatch: "bg-cal-6",
  },
} as const;

export type CalendarColorKey = keyof typeof calendarColors;

export const ownEventColor = {
  name: "Blue",
  stripe: "border-l-ring",
  tint: "bg-ring/10",
  swatch: "bg-ring",
} as const;
